import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import numberFormatter from "utils/numberFormatter";
import KPIFact from "components/visuals/KPIFact";

import {selectors } from "modules/customer/insights/range/sales/historicSales";

const RevenueLastYear = () => {
    
    const revenueLastYear = useSelector((state) =>selectors.revenueLastYear(state));
    const { loading, error, /*placeholder*/ } = revenueLastYear;
    const valueFormatted = numberFormatter.toGBP("2000", 1);
    const label = "Revenue last year KPI Fact placeholder";

    return (
        <Box width="100%" height="100%" data-cy="revenue-last-year">
            <KPIFact loading={loading} error={error} label={label} value={valueFormatted} />
        </Box>
    );
};

export default RevenueLastYear;

